export default function Vercel() {
  return (
    <>
      <svg
        width="129"
        height="30"
        viewBox="0 0 129 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="hidden md:block"
      >
        <title>Vercel</title>
        <path
          d="M64.317 8.05969C59.3144 8.05969 55.7076 11.3222 55.7076 16.2159C55.7076 21.1097 59.7676 24.3722 64.7701 24.3722C67.7924 24.3722 70.4568 23.1759 72.1062 21.1595L68.6398 19.1567C67.7245 20.1581 66.3334 20.7427 64.7701 20.7427C62.5996 20.7427 60.7554 19.6098 60.0712 17.7973H72.7677C72.8674 17.2899 72.9263 16.7642 72.9263 16.2114C72.9263 11.3222 69.3195 8.05969 64.317 8.05969ZM60.0304 14.63C60.5968 12.822 62.1465 11.6847 64.3124 11.6847C66.4829 11.6847 68.0326 12.822 68.5945 14.63H60.0304ZM113.109 8.05969C108.107 8.05969 104.5 11.3222 104.5 16.2159C104.5 21.1097 108.56 24.3722 113.563 24.3722C116.585 24.3722 119.249 23.1759 120.899 21.1595L117.432 19.1567C116.517 20.1581 115.126 20.7427 113.563 20.7427C111.392 20.7427 109.548 19.6098 108.864 17.7973H121.56C121.66 17.2899 121.719 16.7642 121.719 16.2114C121.719 11.3222 118.112 8.05969 113.109 8.05969ZM108.827 14.63C109.394 12.822 110.944 11.6847 113.109 11.6847C115.28 11.6847 116.83 12.822 117.391 14.63H108.827ZM91.142 16.2159C91.142 18.9347 92.9182 20.7472 95.6732 20.7472C97.5401 20.7472 98.9402 19.8998 99.6607 18.5178L103.141 20.5252C101.7 22.9267 98.9991 24.3722 95.6732 24.3722C90.6662 24.3722 87.0638 21.1097 87.0638 16.2159C87.0638 11.3222 90.6707 8.05969 95.6732 8.05969C98.9991 8.05969 101.695 9.50516 103.141 11.9067L99.6607 13.9141C98.9402 12.532 97.5401 11.6847 95.6732 11.6847C92.9227 11.6847 91.142 13.4972 91.142 16.2159ZM128.516 3.07532V23.9191H124.438V3.07532H128.516ZM17.1512 0.809692L33.8941 29.8097H0.408203L17.1512 0.809692ZM59.0109 3.07532L46.4548 24.8253L33.8987 3.07532H38.6066L46.4548 16.6691L54.3029 3.07532H59.0109ZM85.7045 8.51282V12.9036C85.2513 12.7722 84.771 12.6816 84.2544 12.6816C81.6218 12.6816 79.7232 14.4941 79.7232 17.2128V23.9191H75.6451V8.51282H79.7232V12.6816C79.7232 10.3797 82.4012 8.51282 85.7045 8.51282Z"
          fill="white"
        />
      </svg>

      <svg
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="md:hidden"
      >
        <g clipPath="url(#Vercel_svg__clip0)">
          <path d="M19.665 5.222L36.33 34.055H3L19.665 5.222z" fill="#F8F9FB" />
        </g>
        <defs>
          <clipPath id="Vercel_svg__clip0">
            <path
              fill="#fff"
              transform="translate(3 3)"
              d="M0 0h33.33v33.33H0z"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
